// extracted by mini-css-extract-plugin
export default {"textFields":"LoginForm_textFields__+p-Dr","rememberMe":"LoginForm_rememberMe__NcRoa","link":"LoginForm_link__MT8CS","buttonWrapper":"LoginForm_buttonWrapper__4lM+r"};